export const handleHookError = (
  err: unknown,
  defaultMessage: string,
  setError: (error: string | null) => void,
): void => {
  if (err instanceof Error) {
    setError(err.message);
  } else {
    setError(defaultMessage);
  }
};
